





















































import { defineComponent, reactive, ref } from '@vue/composition-api';

import {
  getJobs,
} from '@/api';
import useDownloadReport from '@/use/useDownloadReport';
import useSubJob from '@/use/useSubJob';

const CommonModalWithJobExporter = defineComponent({
  setup() {
    const { list: processStatusList, subJobFilter } = useSubJob();
    const { getCSVReport } = useDownloadReport();

    const modal = ref(null);
    function open() {
      (modal.value as any).open();
    }
    function close() {
      (modal.value as any).close();
    }

    const csvReportVariables = reactive({
      selectedJobs: [],
      searchString: undefined,
      filterProcessStatus: undefined,
      filterSubJob: '',
      hasPoItems: '',
      hasPrItems: '',
      range: {
        from: undefined,
        to: undefined,
      },
    });
    function clearCSVReportFilter() {
      csvReportVariables.selectedJobs = [];
      csvReportVariables.searchString = undefined;
      csvReportVariables.filterProcessStatus = undefined;
      csvReportVariables.hasPoItems = '';
      csvReportVariables.hasPrItems = '';
      csvReportVariables.range = {
        from: undefined,
        to: undefined,
      };
    }
    function exportCSVReport() {
      let variables = {
        filterBomIds: csvReportVariables.selectedJobs.length > 0 ? csvReportVariables.selectedJobs.map((job: any) => job.id) : undefined,
        searchString: csvReportVariables.searchString ? csvReportVariables.searchString : undefined,
        hasPoItems: csvReportVariables.hasPoItems,
        hasPrItems: csvReportVariables.hasPrItems,
        from: undefined,
        to: undefined,
      };
      if (csvReportVariables.range.from) {
        variables.from = csvReportVariables.range.from;
        variables.to = csvReportVariables.range.to;
      }
      if (csvReportVariables.filterSubJob !== '') {
        variables = { ...variables, ...((subJobFilter as any)[csvReportVariables.filterSubJob]) };
      }

      getCSVReport('bom_items', 'csv', 'bom_item', variables);
      clearCSVReportFilter();
    }

    return {
      modal,
      open,
      close,
      getJobs,
      getCSVReport,
      clearCSVReportFilter,
      exportCSVReport,
      processStatusList,
      subJobFilter,
      csvReportVariables,
    };
  },
});

export default CommonModalWithJobExporter;
